import { MOSCOW_REGION_ID } from '@constants/regions';

export const isOtherRegion = (regionId?: number | string | null): boolean =>
  regionId !== null &&
  regionId !== undefined &&
  Number(regionId) !== MOSCOW_REGION_ID;
